import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Banner } from '@zillow/constellation';
import { stringHelper } from '@zg-rentals/rental-manager-env';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import { useSelector } from '../../selectors/useSelector';
import DashboardCSEvents from '../../model/ClickstreamEvent/DashboardCSEvents';
import { StyledAnchor } from './styles';

const RestrictedListingBanner = ({ isFromDashboard = false }: { isFromDashboard?: boolean }) => {
  const history = useHistory();

  const { updateActiveStatus, active, listingAlias, user, currentProperty } = useSelector((state) => ({
    updateActiveStatus: state.properties.currentProperty.updateActiveStatus,
    active: state.properties.currentProperty.active,
    listingAlias: state.properties.currentProperty.listingAlias,
    user: state.user,
    currentProperty: state.properties.currentProperty,
  }));

  const shouldRenderBanner = !updateActiveStatus.isAllowed && !active;
  const triggerLocation = isFromDashboard ? 'zrm_property_overview' : 'posting_path_review';

  useEffect(() => {
    if (shouldRenderBanner) {
      DashboardCSEvents.ViewRestrictedListingBanner({
        user,
        currentProperty,
        triggerLocation,
      });
    }
  }, [isFromDashboard, shouldRenderBanner]);

  const handleUrlClick = (event: React.MouseEvent<HTMLAnchorElement>, url: string, text: string) => {
    const triggerObject = text
      .toLowerCase()
      .replace(
        /\s+/g,
        '_',
      ) as (typeof DashboardCSEvents.BLOCKED_LISTING_TRIGGER_OBJECTS)[keyof typeof DashboardCSEvents.BLOCKED_LISTING_TRIGGER_OBJECTS];
    DashboardCSEvents.ClickContactSupportFromRestrictedBanner({
      user,
      currentProperty,
      triggerLocation,
      triggerObject,
    });

    // SecurityInquiryPage needs listingAlias to be passed via the state
    if (stringHelper.getLastPieceFromPath(url) === 'security-inquiry') {
      event?.preventDefault();
      history.push(url, { listingAlias });
    }
  };

  return shouldRenderBanner ? (
    <Banner
      appearance="warning"
      body={
        <PartialMessage
          onUrlClick={handleUrlClick}
          partialMessages={updateActiveStatus.partialMessages}
          linkComponent={StyledAnchor}
          eventId={DashboardCSEvents.ClickContactSupportFromRestrictedBanner.data_event_id}
        />
      }
      data-eventid={DashboardCSEvents.ViewRestrictedListingBanner.data_event_id}
      data-eventdescription="View restricted listing banner"
    />
  ) : null;
};

export default RestrictedListingBanner;
